<template>
  <v-card min-width="208px">
    <v-navigation-drawer permanent>
      <v-list dense nav>
        <v-list-item-group>
          <router-link to="/Investometer">
            <v-list-item :class="checkUrl(0) ? 'active' : ''">
              <v-img
                :src="checkUrl('0') ? Investometer_active : Investometer"
                :lazy-src="checkUrl('0') ? Investometer_active : Investometer"
              >
              </v-img>
              <v-list-item-content>
                <v-list-item-title>Investometer</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link :to="investment_url">
            <v-list-item
              @click.native="categoryAndSubcategory"
              :class="checkUrl(1) ? 'active' : ''"
            >
              <v-img
                :src="checkUrl('1') ? Investment_active : Investment"
                :lazy-src="checkUrl('1') ? Investment_active : Investment"
              >
              </v-img>

              <v-list-item-content>
                <v-list-item-title>Investment</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link :to="liabilities_url">
            <v-list-item
              @click.native="categoryAndSubcategory"
              :class="checkUrl(2) ? 'active' : ''"
            >
              <v-img
                :src="checkUrl('2') ? Liabilities_active : Liabilities"
                :lazy-src="checkUrl('2') ? Liabilities_active : Liabilities"
              >
              </v-img>
              <v-list-item-content>
                <v-list-item-title>Liabilities</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link :to="keep_safe_url">
            <v-list-item
              @click.native="categoryAndSubcategory"
              :class="checkUrl(3) ? 'active' : ''"
            >
              <v-img
                :src="checkUrl('3') ? KeepSafe_active : KeepSafe"
                :lazy-src="checkUrl('3') ? KeepSafe_active : KeepSafe"
              >
              </v-img>
              <v-list-item-content>
                <v-list-item-title>KeepSafe</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          
          <router-link to="/value-added-services">
            <v-list-item
              @click.native="categoryAndSubcategory"
              :class="checkUrl(7) ? 'active' : ''"
            >
              <v-img
                :src="checkUrl('7') ? Wills_active : Wills"
                :lazy-src="checkUrl('7') ? Wills_active : Wills"
              >
              </v-img>
              <v-list-item-content>
                <v-list-item-title>Value Added Services</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/FinTalk">
            <v-list-item :class="checkUrl(8) ? 'active' : ''">
              <v-img
                :src="checkUrl('8') ? FinTalk_active : FinTalk"
                :lazy-src="checkUrl('8') ? FinTalk_active : FinTalk"
              >
              </v-img>
              <v-list-item-content>
                <v-list-item-title>FinTalk</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            </router-link>
           <router-link to="/FinStat">
            <v-list-item :class="checkUrl(9) ? 'active' : ''">
              <v-img
                :src="checkUrl('9') ? FinStat_active : FinStat"
                :lazy-src="checkUrl('9') ? FinStat_active : FinStat"
              >
              </v-img>
              <v-list-item-content>
                <v-list-item-title>FinStat</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/accounts-dashboard">
            <v-list-item
              @click.native="categoryAndSubcategory"
              :class="checkUrl(4) ? 'active' : ''"
            >
              <v-img
                :src="checkUrl('4') ? Accounts_active : Accounts"
                :lazy-src="checkUrl('4') ? Accounts_active : Accounts"
              >
              </v-img>
              <v-list-item-content>
                <v-list-item-title>Accounts</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
          <router-link to="/Dashboard">
            <v-list-item :class="checkUrl(5) ? 'active' : ''">
              <v-img
                :src="checkUrl('5') ? profile_active : profile_inactive"
                :lazy-src="checkUrl('5') ? profile_active : profile_inactive"
              >
              </v-img>
              <v-list-item-content>
                <v-list-item-title>Profile</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>

          <router-link to="/ContactUsForm">
            <v-list-item :class="checkUrl(6) ? 'active' : ''">
              <v-img
                :src="checkUrl('6') ? contact_us_active : contact_us_inactive"
                :lazy-src="
                  checkUrl('6') ? contact_us_active : contact_us_inactive
                "
              >
              </v-img>
              <v-list-item-content>
                <v-list-item-title>Contact Us</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </router-link>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </v-card>
</template>

<script>
import { POST_API, GET_API } from '../../store/actions.type';
import ApiService from '../../api/api.service';
import JwtService from '.././common/jwt.service';

export default {
  data() {
    return {
      selected: this.$route.meta.siderBarMenu,
      Investometer: process.env.VUE_APP_ROOT_ICONS_URL + 'Investometer.png',
      Investometer_active:
        process.env.VUE_APP_ROOT_ICONS_URL + 'Investometer_active.png',
      Investment: process.env.VUE_APP_ROOT_ICONS_URL + 'Investment.png',
      Investment_active:
        process.env.VUE_APP_ROOT_ICONS_URL + 'Investment_active.png',
      Liabilities: process.env.VUE_APP_ROOT_ICONS_URL + 'Liabilities.png',
      Liabilities_active:
        process.env.VUE_APP_ROOT_ICONS_URL + 'ic_active_liabilities.png',
      KeepSafe: process.env.VUE_APP_ROOT_ICONS_URL + 'KeepSafe.png',
      KeepSafe_active:
        process.env.VUE_APP_ROOT_ICONS_URL + 'KeepSafe_active.png',
      Accounts: process.env.VUE_APP_ROOT_ICONS_URL + 'Accounts.png',
      Accounts_active:
        process.env.VUE_APP_ROOT_ICONS_URL + 'Account_active.png',
      Wills: process.env.VUE_APP_ROOT_ICONS_URL + 'Wills.png',
      Wills_active: process.env.VUE_APP_ROOT_ICONS_URL + 'Will_active.png',
      profile_inactive:
        process.env.VUE_APP_ROOT_ICONS_URL + 'profile_inactive.png',
      profile_active: process.env.VUE_APP_ROOT_ICONS_URL + 'profile_active.png',
      contact_us_inactive:
        process.env.VUE_APP_ROOT_ICONS_URL + 'contact_us_inactive.png',
      contact_us_active:
        process.env.VUE_APP_ROOT_ICONS_URL + 'contact_us_active.png',

      FinTalk: process.env.VUE_APP_ROOT_ICONS_URL + 'FinTalk.png',
      FinTalk_active:process.env.VUE_APP_ROOT_ICONS_URL + 'FinTalk_active.png',

      FinStat: process.env.VUE_APP_ROOT_ICONS_URL + 'FinStat.png',
      FinStat_active:process.env.VUE_APP_ROOT_ICONS_URL + 'FinStat_active.png',
      error_message: '',
      success_message: '',
      investment_url: '/Investment',
      liabilities_url: '/liabilities-dashboard',
      keep_safe_url: '/category',
      account_url: '/accounts-dashboard',
      deposit_count: 0,
      liability_count: 0,
      keepsafe_count: 0,
      account_count: 0,
      flag: 0,
    };
  },
  computed: {},
  created() {
    this.appendData();
  },

  computed() {
    this.appendData();
    this.flag = 0;
  },

  methods: {
    categoryAndSubcategory() {},

    checkUrl(val) {
      this.appendData();

      if (this.$route.meta.siderBarMenu == '1') {
        if (this.deposit_count == 0) {
          if (this.$route.name == 'Investment') {
            swal.fire({
              icon: 'info',
              text: 'Digitise and monitor your investment across asset class.',
            });
          }
        }
      } else if (this.$route.meta.siderBarMenu == '2') {
        if (this.liability_count == 0) {
          this.liabilities_url = '/liabilities-subcategory';
          if (this.$route.name == 'liabilities-subcategory') {
            swal
              .fire({
                icon: 'info',
                text: 'Digitise and monitor your liabilites.',
              })
              .then((result) => {
                this.$router.push({
                  name: 'liabilities-subcategory',
                  params: {},
                });
              });
          }
        } else {
          this.liabilities_url = '/liabilities-dashboard';
        }
      } else if (this.$route.meta.siderBarMenu == '3') {
        if (this.$route.name == 'KeepSafeCategory') {
          swal.fire({
            icon: 'info',
            text: "Secure financial documents with Nimeya's encrypted vault-Keepsafe. It provides complete privacy and protection of your information",
          });
        }
      } else if (this.$route.meta.siderBarMenu == '4') {
        if (this.account_count == 0) {
          this.account_url = '/accounts-subcategory';
          if (this.$route.name == 'accounts-subcategory') {
            swal.fire({
              icon: 'info',
              text: 'Digitise and monitor your account related details.',
            });
          }
        } else {
          this.account_url = '/accounts-dashboard';
        }
      }

      if (this.$route.name != 'Notification') {
        return this.$route.meta.siderBarMenu == val ? true : false;
      } else {
      }
    },
    checkImage(val) {
      return this.$route.meta.siderBarMenu;
    },

    appendData() {
      if (this.flag == 0) {
        this.flag = 1;
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        ApiService.setHeader();
        ApiService.post('check-user-plan', {
          aws_cognito_id: cognito_idp,
        }).then((response) => {
          localStorage.setItem(
            'allow_user_activity',
            response.data.allow_user_activity
          );
          this.deposit_count = response.data.deposit_count;
          this.liability_count = response.data.liability_count;
          this.keepsafe_count = response.data.keepsafe_count;
          this.account_count = response.data.account_count;
        });
      }
    },
  },
};
</script>
